export const DEFAULT_FONT = 'defaultFont';
export const CUSTOM_GOOGLE_FONT_FAMILY = 'customGoogleFontFamily';
export const CUSTOM_FONT = 'customFont';
export const DEFAULT_GOOGLE_FONT = 'Open Sans';
